<script>
  import { navigate } from 'svelte-routing';
  import ActionMenu from './Components/Common/ActionMenu/ActionMenu.svelte';
  import ActionMenuItem from './Components/Common/ActionMenu/ActionMenuItem.svelte';
</script>

<div class="container">
  <ActionMenu buttonIcon="menu" maxHeight="auto">
    <ActionMenuItem title="Chat" on:click={() => navigate('/chat')} />
    <!-- <ActionMenuItem title="Meldinger" on:click={() => navigate('/meldinger')} />
    <ActionMenuItem title="Spillelister" on:click={() => navigate('/spillelister')} />
    <ActionMenuItem title="Profiler" on:click={() => navigate('/profiler')} /> -->
  </ActionMenu>
</div>
